import { render, staticRenderFns } from "./modalDetallesPostulacion.vue?vue&type=template&id=332db920&"
import script from "./modalDetallesPostulacion.vue?vue&type=script&lang=js&"
export * from "./modalDetallesPostulacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports